import { SocialButtonType } from '@widgets/SocialShare/types'
import config from '@config'

const { socialembeds } = config

type GetSocialEmbedConfigType = {
  utmMedium: string
  utmCampaign: string
  utmSource?: string
  iconName: string
}

const getSocialEmbedConfig = (
  type: SocialButtonType
): GetSocialEmbedConfigType => {
  const { utmMedium, utmCampaign, types } = socialembeds.share
  const socialembedsByTypes = types[type] || {}
  return {
    utmMedium,
    utmCampaign,
    ...socialembedsByTypes,
  }
}

const getUrlEncodedUTMParameters = (
  utmMedium: string,
  utmCampaign: string
): string =>
  `%3Futm_medium%3D${utmMedium}%26utm_campaign%3D${utmCampaign}%26utm_source%3D`

export { getSocialEmbedConfig, getUrlEncodedUTMParameters }
